import { gql } from "@apollo/client";

export const GET_PROFESIONALES_EVALUACION = gql`
query ProfesionalesEvaluacion($idEvaluacion: Int!) {
    profesionalesByEvaluacion(idEvaluacion: $idEvaluacion) {
        idProfesionalNavigation {
          idProfesional
          nombre
          apellido
        }
        idFiguraProfesional
        idFiguraProfesionalNavigation {
          descripcion
        }
        idTipoProfesional
        idTipoProfesionalNavigation {
          descripcion
        }
    }
}`;

const adaptProfesional = (profesional) => {
  const { idProfesionalNavigation, idFiguraProfesionalNavigation, idTipoProfesionalNavigation, idTipoProfesional, idFiguraProfesional } = profesional;

  const tipoDesc = idTipoProfesionalNavigation?.descripcion || '';
  const figuraDesc = idFiguraProfesionalNavigation?.descripcion || '';

  return {
    id: idProfesionalNavigation?.idProfesional || 0,
    displayName: `${idProfesionalNavigation?.apellido} ${idProfesionalNavigation?.nombre}`.trim(),
    descripcion: `${tipoDesc}${figuraDesc ? ` - ${figuraDesc}` : ''}`.trim(),
    idTipoProfesional: idTipoProfesional,
    idFiguraProfesional: idFiguraProfesional,
    figuraProfesional: figuraDesc 
  };
};

const listaSinRepetidos = (lista) => {
    const ocurrencias = lista.reduce((acc, item) => {
        acc[item.id] = (acc[item.id] || 0) + 1;
        return acc;
    }, {});

    return lista
        .filter(
            (item, index, self) =>
                index === self.findIndex(x => x.id === item.id)
        )
        .map(item => ({
            ...item,
            descripcion: ocurrencias[item.id] > 1 ? item.descripcion?.split(' - ')[0] : item.descripcion,
            tieneRepetidos: ocurrencias[item.id] > 1
        }));
};

export const adaptProfesionales = (data) => {
  const adaptedData = data?.profesionalesByEvaluacion?.map((profesional) => adaptProfesional(profesional));
  
  return listaSinRepetidos(adaptedData);
};